import { LastMovement } from '../../core/entities/general/LastMovement.entity';
import { LastTransaction } from '../../core/entities/general/LastTransaction.entity';
import { LastTransactionResponse } from '../interfaces/last-transaction.interface';

export class LastTransactionMapper {
  static fromResponseToEntity(
    response: LastTransactionResponse
  ): LastTransaction {
    return new LastTransaction(
      response.page,
      response.totalPages,
      response.data.map(
        (movement) =>
          new LastMovement(
            movement.date,
            movement.accountName,
            movement.accountType,
            movement.detail,
            movement.amount,
            movement.transactionId,
            movement.bankId
          )
      )
    );
  }
}
